import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';
import { Menu } from 'antd';

// import { addToPlaylist } from '../../actions';
import NewPlaylist from './NewPlaylist';
import { UsergroupAddOutlined } from '@ant-design/icons';
import NewTag from '../Common/NewTag';
import { bindActionCreators } from 'redux';
import { addPodcastToTag } from '../../actions';
import SubMenu from 'antd/lib/menu/SubMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AddToTag extends Component {
    addPodcastToTagFn(tagId) {
        const { podcast, userDetails, podcastTags } = this.props;
        //get firestore Id from slug Id
        // const { userPlaylists } = this.props;
        // const index = Object.values(userPlaylists).findIndex(item => item.slug === playlistSlugId);
        // const firestoreId = Object.keys(userPlaylists)[index];
        this.props.addPodcastToTag(tagId, { [podcast.collectionId]: true });
    }

    isInTag = (tagId) => {
        const { podcast, userDetails, podcastTags } = this.props;
        const tagMap = podcastTags[tagId] ?? {};
        let collectionIdsMap = tagMap['podcasts'] ?? {};
        return collectionIdsMap[podcast.collectionId];
    }

    render() {
        const { podcast, userDetails, podcastTags } = this.props;
        console.dir(podcast);
        return (
            <span>
                <SubMenu title={<div style={{ display: 'inline' }}>
                    <p style={{ display: 'inline' }}>
                        {/* {this.isInAnyPlaylist() ? <CheckCircleOutlined style={{ color: 'green' }} /> : <PlusCircleOutlined />}&nbsp; */}
                        Add to Collection &nbsp;
                    </p></div>}>

                    <Menu.Item key="newPlaylist"><NewTag podcastDetails={podcast} /></Menu.Item>
                    <Menu.Divider />
                    {userDetails && Object.keys(podcastTags).length > 0 && Object.keys(podcastTags).map((tagId, ind) => (
                        <Menu.Item key={ind}>
                            <a onClick={this.addPodcastToTagFn.bind(this, tagId)}>
                                <FontAwesomeIcon icon={['fas', this.isInTag(tagId) ? 'check' : 'plus']} style={{ fontSize: `12px` }} />&nbsp; &nbsp;
                                {podcastTags[tagId].name}</a>
                        </Menu.Item>
                    ))
                    }
                </SubMenu>
            </span>
        )
    }
}

AddToTag.propTypes = {
    podcast: PropTypes.object,
    userDetails: PropTypes.object,
    podcastTags: PropTypes.object,
    addPodcastToTag: PropTypes.func
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        podcastTags: state.podcastTags,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addPodcastToTag: bindActionCreators(addPodcastToTag, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToTag)
